import React from 'react';
import { Flame } from 'lucide-react';
import { useRituals } from './RitualContext';
import { RitualIcon } from '../icons/RitualIcon';
interface RitualTrackerWidgetProps {
  onOpenRitualBoard: () => void;
}
export const RitualTrackerWidget: React.FC<RitualTrackerWidgetProps> = ({
  onOpenRitualBoard
}) => {
  const {
    todayCompletedCount,
    totalDailyRituals,
    streakCount,
    hasUnclaimedRewards
  } = useRituals();
  // Calculate percentage for progress ring
  const progressPercentage = todayCompletedCount / totalDailyRituals * 100;
  return <button onClick={onOpenRitualBoard} className="relative flex items-center gap-2 px-3 py-1.5 bg-of-gray dark:bg-gray-800 rounded-md text-of-text-primary dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700 transition-all group" data-id="element-18458">
      <div className="relative" data-id="element-18459">
        {/* Progress ring around ritual icon */}
        <div className="w-7 h-7 rounded-full flex items-center justify-center" data-id="element-18460">
          <svg className="absolute w-7 h-7 -rotate-90" data-id="element-18461">
            <circle cx="14" cy="14" r="12" fill="none" stroke="currentColor" strokeOpacity="0.2" strokeWidth="2" data-id="element-18462" />
            <circle cx="14" cy="14" r="12" fill="none" stroke="url(#ritual-progress-gradient)" strokeWidth="2" strokeDasharray={2 * Math.PI * 12} strokeDashoffset={2 * Math.PI * 12 * (1 - progressPercentage / 100)} className="transition-all duration-500 ease-out" data-id="element-18463" />
            <defs data-id="element-18464">
              <linearGradient id="ritual-progress-gradient" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-18465">
                <stop offset="0%" stopColor="#EC4899" data-id="element-18466" />
                <stop offset="100%" stopColor="#8B5CF6" data-id="element-18467" />
              </linearGradient>
            </defs>
          </svg>
          <RitualIcon size={16} state={hasUnclaimedRewards ? 'active' : 'default'} className="text-gray-500 dark:text-gray-400" data-id="element-18468" />
        </div>
      </div>
      {/* Progress text - hidden on mobile */}
      <div className="hidden sm:flex flex-col items-start leading-none" data-id="element-18469">
        <span className="text-xs font-medium" data-id="element-18470">
          {todayCompletedCount}/{totalDailyRituals}
        </span>
        <div className="flex items-center gap-0.5" data-id="element-18471">
          <Flame size={10} className="text-amber-500" data-id="element-18472" />
          <span className="text-[10px] text-amber-500 font-medium" data-id="element-18473">
            {streakCount}
          </span>
        </div>
      </div>
    </button>;
};